import { render, staticRenderFns } from "./CompanyMerge.vue?vue&type=template&id=4c3718fa&"
import script from "./CompanyMerge.vue?vue&type=script&lang=js&"
export * from "./CompanyMerge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports